import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { AddToTrolley } from '@sainsburys-tech/bolt'
import FableAddToTrolleyButton from '../FableAddToTrolleyButton/FableAddToTrolleyButton'
import AddToTrolleyButtonWrapper from '../AddToTrolleyButtonWrapper/AddToTrolleyButtonWrapper'

const { Button: AddToTrolleyButton } = AddToTrolley

const BRAND = process.env.BRAND || 'ARGOS'

const getDisplayPrice = (items, price) => {
  if (!price) return null
  const currentProductPrice = price.now
  const bundlePrice = items.reduce((sum, item) => sum + item.price, 0)
  const totalPrice = bundlePrice + currentProductPrice
  return totalPrice.toFixed(2)
}

const addToTrolleyClickOrigin = 'PDP:fbtBundleATT'

class BundleSummary extends Component {
  getProductListTracking = () => {
    const { analyticsOptions } = this.props
    const productList = [analyticsOptions?.bundleItems?.main, ...(analyticsOptions?.bundleItems?.additional || [])]
    return productList
  }

  addBundleToTrolley = () => {
    const { analyticsOptions } = this.props
    const productList = this.getProductListTracking()
    AddToTrolley.onAddToTrolleyModalOpen(productList)(addToTrolleyClickOrigin, analyticsOptions)()
  }

  onTuRequestSuccess = () => {
    window.dispatchEvent(new CustomEvent('cartupdate'))
  }

  render() {
    const { items, price, partNumber, analyticsOptions } = this.props
    const partNumberList = [partNumber, ...items.map(item => item.id)]
    const displayPrice = getDisplayPrice(items, price)
    const caption = 'Total price for all items:'

    const backgroundClass = 'xs-12--none md-4--none deal__summary'
    const summaryLabelsClass = 'bundle__summary-price'
    const dataTest = 'frequently-bought-together-add-to-trolley'

    const productList = this.getProductListTracking()

    const trackingParams = {
      clickOrigin: addToTrolleyClickOrigin,
      products: productList,
      bundleOptions: analyticsOptions
    }

    return (
      <BundleSummaryContainer className={backgroundClass}>
        <BundleSummaryLabels {...{ displayPrice, className: summaryLabelsClass }}>
          <BundleSummaryCaption {...{ caption }} />
          <BundlePriceLabel {...{ displayPrice }} />
        </BundleSummaryLabels>
        <AddToTrolleyButtonWrapper>
          <AddToTrolleyButton
            partNumber={partNumberList}
            full
            openView
            disableRecommendations
            onClick={this.addBundleToTrolley}
            onTrolleyRequestSuccess={BRAND === 'TU' ? this.onTuRequestSuccess : null}
            data-test={dataTest}
          />
          <FableAddToTrolleyButton
            full
            productId={partNumber}
            bundleItems={items.map(item => item.id)}
            quantity={1}
            trackingParams={trackingParams}
            data-test={dataTest}
          />
        </AddToTrolleyButtonWrapper>
      </BundleSummaryContainer>
    )
  }
}

BundleSummary.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  partNumber: PropTypes.string,
  price: PropTypes.object,
  analyticsOptions: PropTypes.object
}

const BundleSummaryCaption = ({ caption }) => <span>{caption}</span>

const BundleSummaryContainer = ({ children, className }) => <div {...{ className }}>{children}</div>

const BundleSummaryLabels = ({ displayPrice, children, className }) =>
  displayPrice && <div {...{ className }}>{children}</div>

const BundlePriceLabel = ({ displayPrice }) => <span>&pound;{displayPrice}</span>

export default BundleSummary
export { BundleSummaryContainer, BundleSummaryLabels, BundlePriceLabel, BundleSummaryCaption }
export { getDisplayPrice }
